<!-- eslint-disable -->
<template>
  <div style="father">
    <div class="father-card">
      <el-form label-position="180" :inline="true" class="demo-form-inline select-card">
        <el-form-item label="选择上传广告位置：">
          <el-select v-model="advertised_value" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain>上传</el-button>
        </el-form-item>
      </el-form>
      <posters :maxCount="8" title="" @rImgList="rImgList">选择图片</posters>
    </div>


    <div class="el-carousel-fa">
      <el-carousel style="width:1000px;" :interval="4000" height="400px">
        <el-carousel-item v-for="item in imgList" :key="item.key">
          <img :src="item.url" style="width:1000px;height:400px" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>
<script>
import posters from "../../components/posters.vue";
export default {
  name: "advertised",
  components: {
    posters
  },
  data() {
    return {
      advertised_value: "",
      home_list: [],
      imgList: [],
      options: [
        { label: "主页广告", value: "index" },
        {
          label: "盘点单广告",
          value: "pda"
        },
        {
          label: "收银报表广告",
          value: "table"
        }
      ]
      /* {
          label: "主页广告",
        },
        {
          label: "盘点单广告",
        },
        {
          label: "主页广告",
        },
        {
          label: "主页广告",
        },
        {
          label: "主页广告",
          value: 8
        },
        {
          label: "主页广告",
          value: 8
        },
        {
          label: "主页广告",
          value: 8
        },
        {
          label: "主页广告",
          value: 8
        }
      ] */
    };
  },
  methods: {
    /* checkShow() {
      console.log("bbbbbbbbbbbbbb");
    }, */
    rImgList(res) {
      this.imgList = [];
      for (var i = 0; i < res.length; i++) {
        this.imgList.push({
          url: res[i]
        });
      }
    }
  }
};
</script>
<style scoped>
.el-carousel-fa {
  display: flex;
  justify-content: center;
  /* background-color: #fff; */
  width: 98%;
  margin: 1%;
  box-shadow: 0 0 20px rgb(230, 230, 230);
  padding: 10px;

}

.father {
  width: 100%;
  height: 100%;
  background-color: #fff;
}

.father-card {
  margin: 1%;
  width: 98%;
  height: 40%;
  /* background-color: pink; */
  box-shadow: 0 0 20px rgb(230, 230, 230);
  padding: 10px;
}

.select-card {
  margin-left: 25px;
  margin-top: 20px;
}
</style>
